/**
 * BroadcastDeleteModal - Modal de confirmação de exclusão
 * Versão mobile-first
 */
import React from 'react'
import { AlertTriangle, Trash2, Bell, Mail } from 'lucide-react'
import { Modal } from '../../components/molecules/Modal'
import Card from '../../components/atoms/Card'
import Button from '../../components/atoms/Button'
import { getBroadcastContent } from '../core/broadcast.utils'

const BroadcastDeleteModal = ({
	isOpen,
	onClose,
	broadcast,
	onConfirm,
	loading,
}) => {
	if (!broadcast) return null

	const content = getBroadcastContent(broadcast)

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Excluir Broadcast"
			size="md"
		>
			<div className="space-y-4 md:space-y-6">
				{/* Warning */}
				<div className="flex items-start gap-2 md:gap-3 p-3 md:p-4 bg-red-500/10 border border-red-500/30 rounded-lg">
					<AlertTriangle className="w-5 h-5 md:w-6 md:h-6 text-red-500 flex-shrink-0 mt-0.5" />
					<div>
						<p className="font-medium text-red-500 text-sm md:text-base">Atenção!</p>
						<p className="text-xs md:text-sm text-text-muted">
							Esta ação é irreversível. O registro será removido permanentemente.
						</p>
					</div>
				</div>

				{/* Preview do que será excluído */}
				<Card className="p-3 md:p-4">
					<p className="text-xs md:text-sm text-text-muted mb-2 md:mb-3">Broadcast a ser excluído:</p>

					<div className="space-y-2 md:space-y-3">
						{content.pushTitle && (
							<div className="flex items-start gap-2">
								<Bell className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" />
								<div className="min-w-0">
									<p className="text-xs md:text-sm font-medium text-text truncate">
										{content.pushTitle}
									</p>
									<p className="text-xs text-text-muted line-clamp-1">
										{content.pushBody}
									</p>
								</div>
							</div>
						)}

						{content.emailSubject && (
							<div className="flex items-start gap-2">
								<Mail className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
								<div className="min-w-0">
									<p className="text-xs md:text-sm font-medium text-text truncate">
										{content.emailSubject}
									</p>
									<p className="text-xs text-text-muted line-clamp-1">
										{content.emailBody}
									</p>
								</div>
							</div>
						)}
					</div>
				</Card>

				{/* Actions - Mobile friendly */}
				<div className="flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-3 pt-2 border-t border-base-200 sm:border-0 sm:pt-0">
					<Button
						variant="outline"
						onClick={onClose}
						disabled={loading}
						className="w-full sm:w-auto"
					>
						Cancelar
					</Button>
					<Button
						variant="danger"
						onClick={onConfirm}
						loading={loading}
						className="w-full sm:w-auto"
					>
						<Trash2 className="w-4 h-4 mr-2" />
						<span className="hidden sm:inline">Excluir Broadcast</span>
						<span className="sm:hidden">Excluir</span>
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default BroadcastDeleteModal
